
import {
  mdiEmailOutline,
  mdiChatOutline,
  mdiGoogleChrome,
  mdiPhoneOutline
} from '@mdi/js'
import ContactForm from '@/components/ui/ContactForm'

export default {
  components: { ContactForm },
  data () {
    return {
      mdiEmailOutline,
      mdiChatOutline,
      mdiGoogleChrome,
      mdiPhoneOutline
    }
  },
  computed: {
    isNl () {
      return this.$i18n.locale === 'nl'
    },

    contacts () {
      if (this.$i18n.locale === 'nl') {
        return {
          email: 'service@caravanmarkt24.nl',
          // phone: { link: 'tel:+32485539754', text: '+32 485 53 97 54' }
          phone: {
            link: 'tel:+493057714320',
            text: '030 57714320'
          }
        }
      }

      return {
        email: 'service@caravanmarkt24.de',
        phone: {
          link: 'tel:+493057714320',
          text: '030 57714320'
        }
      }
    }
  },
  methods: {
    openChat () {
      window.HubSpotConversations?.widget.open()
    }
  }
}
